import { connect } from 'react-redux'
import * as selector from '../../state/plan/selector'
import ModelSelection from '../plan/ModelSelection'
import { selectProcessContext } from '../../../process/state/instance-detail/selector'
import { changeProcessContext, saveProcessContext } from '../../../process/state/instance-detail/action'
import { selectSalesOrder } from '../../../sales-order/state/detail/selector'

const mapStateToProps = (state, props) => {
    const salesOrder = selectSalesOrder(state)
    const alignerLabelList = (salesOrder.type === 'treatment' || salesOrder.type === 'treatment-new') ? selector.selectAlignerLabelListProduction(state, salesOrder) : selector.selectAlignerLabelListReproduction(state)

    return {
        treatmentPlan: selector.selectTreatmentPlan(state),
        alignerLabelList: alignerLabelList,
        processContext: selectProcessContext(state),
    }
}

const mapDispatchToProps = {
    changeProcessContext,
    saveProcessContext,
}


export default connect(mapStateToProps, mapDispatchToProps)(ModelSelection)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/ModelSelectionWidgetContainer.js